export enum AbilityActions {
  use = 'use',
  create = 'create',
  edit = 'edit',
  delete = 'delete',
  see = 'see',
  cancel = 'cancel',
}
